import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ColumnSelectorListComponent } from './column-selector-list.component';
import { IonicModule } from '@ionic/angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [ColumnSelectorListComponent],
  exports: [ ColumnSelectorListComponent ]
})
export class ColumnSelectorListModule { }
